import React, { useState } from "react";
import Flags from "./Flags";
import Tooltips from "./Tooltips";
import { handleState, transformDate } from "../../Utils/utils";
import IconTableDown from "../../Resources/svg/Icons/IconTableDown";

const CardTablaRequestRVO = ({ data }) => {
  const [collapse, setCollapse] = useState(false);

  const {
    estado,
    descripcionEstado,
    nroOperacion,
    CUSPP,
    afiliado: { nroDoc },
    fechaCargaXML,
    fechaCierre,
  } = data || null;
  const remuneracionPromedio = data.remuneracionPromedio
    ? data.remuneracionPromedio
    : "-";

  const handleCardStateTable = () => {
    setCollapse((c) => !c);
  };

  return (
    <div className="card-table">
      <div className="flag-state-info">
        <Flags variant={estado}>{handleState(estado)}</Flags>
        <Tooltips text={descripcionEstado} />
      </div>
      <div className={`card-table__icon`} onClick={handleCardStateTable}>
        <IconTableDown className={`${collapse ? "up" : "down"}`} />
      </div>
      <div className="card-table__box">
        <div className="card-table__description">N° Operación:</div>
        <div className="card-table__data">{nroOperacion}</div>
        <div className="card-table__description">CUSPP:</div>
        <div className="card-table__data">{CUSPP}</div>
        <div className="card-table__description">DNI:</div>
        <div className="card-table__data">{nroDoc}</div>
        {collapse && (
          <>
            <div className="card-table__description">Fec. Solicitud:</div>
            <div className="card-table__data">{transformDate(fechaCargaXML)}</div>
            <div className="card-table__description">Fec. Cierre:</div>
            <div className="card-table__data">{transformDate(fechaCierre)}</div>
            <div className="card-table__description">Rem. Promedio:</div>
            <div className="card-table__data">{remuneracionPromedio}</div>
          </>
        )}
      </div>
    </div>
  );
};

export default CardTablaRequestRVO;
